import { hasLocalStorage } from 'app/utils/caniuse';
class MemStorage {
    constructor() {
        Object.defineProperty(this, "data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
    }
    get length() {
        return this.data.size;
    }
    getItem(key) {
        return this.data.get(key);
    }
    setItem(key, value) {
        this.data.set(key, value);
    }
    removeItem(key) {
        this.data.delete(key);
    }
    clear() {
        this.data.clear();
    }
    key(index) {
        if (index < 0 || index >= this.length) {
            return undefined;
        }
        const keys = [...this.data.keys()];
        return keys[index];
    }
}
export function storage(key) {
    const lc = hasLocalStorage()
        ? window.localStorage
        : new MemStorage();
    return {
        get: () => lc.getItem(key),
        set: (value) => lc.setItem(key, value),
        clear: () => lc.removeItem(key),
    };
}
